import { paginationConstants } from '../constants'
// import { paginationService } from '../services'
import { alertActions } from './'

export const paginationActions = {
  setPage
}

/*********
 보관
**********/

function setPage(page) {
  return async dispatch => {
    dispatch(request(page))

    // keepService.keep(id)
    // .then(
    //   response => {
    //     dispatch(success(response))
    //   },
    //   error => {
    //     dispatch(failure(error))
    //     dispatch(alertActions.error({
          //   title: null,
          //   message: errorMessages.systemError
          // }))
    //   }
    // )
  }
  function request(page) {
    return {
      type: paginationConstants.PAGINATION_REQUEST,
      page
    }
  }
//   function success(response) {
//     return {
//       type: keepConstants.KEEP_OPEN_SUCCESS,
//       response
//     }
//   }
//   function failure(response) {
//     return {
//       type: keepConstants.KEEP_OPEN_FAILURE,
//       response
//     }
//   }
}
